module.exports = __webpack_public_path__ + "st.svg?c8b75a73c74e95cef2061883039a35a3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/st.svg
// module id = 1135
// module chunks = 27